<template>
  <div class="animated fadeIn">
    <b-card>
      <div class="display-table full-width mb-2">
        <strong class="card-title">Dashboard Pelaku Usaha</strong>
      </div>
      <b-row>
        <b-col md="4">
          <select class="form-control mb-3" v-model="models.year" @change="getData">
            <option value="2024">2024</option>
            <option value="2025">2025</option>
          </select>
        </b-col>
      </b-row>
      <b-row>
        <h5 class="col-md-12 px-3 mb-3"><b>Dashboard Pemantauan Sampah B3 dan LB3 DLH Pemprov DKI Jakarta</b></h5>
        <b-col md="4">
          <chartJenisSektorIndustri :models="models"/>
        </b-col>
        <b-col md="4">
          <chartTimbulanLimbah :models="models"/>
        </b-col>
        <b-col md="4">
          <p class="subtitle">Timbulan Limbah B3 Pelaku Usaha, tahun 2024</p>
          <div id="map" :style="{ height: '300px' }"></div>
        </b-col>
        <b-col md="4">
         <chartLimbahTerkelola :models="models"/>
        </b-col>
        <!-- <b-col md="4">
          <p class="subtitle">Lokasi Jasa Pengelolaan Limbah yang Paling Banyak Digunakan, tahun {{ models.year }} dalam (ton)</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Kota/Kabupaten</th>
                  <th class="bg-green">Jumlah</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in pengolahanLimbahTerbanyak" :key="k">
                  <td>{{v.namaKota }}</td>
                  <td align="right">{{ v.jumlahLimbah }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col> -->
        <b-col md="4">
          <p class="subtitle">Jumlah dan Jenis Dokumen Pelaku Usaha tahun 2024</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Jenis Dokumen</th>
                  <th class="bg-green">Jumlah</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in jenisDokumen" :key="k">
                  <td>{{ v.nomorManifest }}</td>
                  <td>{{v.jumlahDokumen}}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </b-col>
        <b-col md="4">
          <p class="subtitle">Timbulan Limbah B3 per Kd. Limbah tahun 2024 dalam(ton)</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Kode Limbah</th>
                  <th class="bg-green">Jumlah</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in timbulanPerKodeLimbah" :key="k">
                  <td>{{ v.kodeLimbah }}</td>
                  <td>{{ v.countLimbah }}</td>
                </tr>
              </tbody>
            </table>


          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style>
.chart{
  width: 100%;
  overflow: scroll;
}
.subtitle{
    font-weight: 900;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 14px;

}
.bg-green{
  background: #169e35;
  color: #fff;
}
</style>

<script>
  import chartJenisSektorIndustri from './chartJenisSektorIndustri';
  import chartTimbulanLimbah from './chartTimbulanLimbah';
  import chartLimbahTerkelola from './chartLimbahTerkelola';
  import moment from 'moment';
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import markerIcon from "leaflet/dist/images/marker-icon.png";
  import markerShadow from "leaflet/dist/images/marker-shadow.png";
  export default {
    name: 'dashboardPelakuUsaha',
    components: {
      chartJenisSektorIndustri,
      chartTimbulanLimbah,
      chartLimbahTerkelola,
    },
    data: function () {
      return {
        models: {
          year: moment().format('YYYY'),
        },
        mapsMarkers: [],
        pengolahanLimbahTerbanyak: [],
        jenisDokumen: [],
        timbulanPerKodeLimbah: [],
        map: null,
      }
    },
    mounted(){
        this.getData();
    },
    methods: {
      getData(){
        this.getMaps();
        this.getPengolahanLimbahTerbanyak();
        this.getJenisDokumen();
        this.getTimbulanPerKodeLimbah();
      },
      getMaps() {
        const _ = this;
        _.$axios.get('PelakuUsahaDashboard/MapsPU', {
          params: {
            years: _.models.year,
          }
        })
        .then(res => {
          _.mapsMarkers = res.data.data;
          _.initMap();
        })
      },
      initMap(){
        const _ = this;

        if (_.map) {
          _.map.remove();
        }

        // Initialize the map
        _.map = L.map('map').setView([-6.2088, 106.8456], 10);

        // Add OpenStreetMap tiles
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(_.map);

        // Set custom marker icon
        const customIcon = L.icon({
          iconUrl: markerIcon,
          shadowUrl: markerShadow,
          iconSize: [25, 41], // Default Leaflet icon size
          iconAnchor: [12, 41], // Anchor the icon properly
        });

        _.mapsMarkers.forEach((marker) => {
          const newMarker = L.marker([marker.longitude, marker.latitude], { icon: customIcon }).addTo(_.map);
          // Add popup if provided
          if (marker.namaKecamatan) {
            newMarker.bindPopup(marker.namaKecamatan + ' : ' + marker.jumlahLimbah + ' ton').openPopup();
          }
        });
      },
      getPengolahanLimbahTerbanyak() {
        const _ = this;
        _.$axios.get('PelakuUsahaDashboard/LokasiPengolahanLimbahPalingBanyak', {
          params: {
            years: _.models.year,
          }
        })
        .then(res => {
          _.pengolahanLimbahTerbanyak = res.data.data;
        })
      },
      getJenisDokumen() {
        const _ = this;
        _.$axios.get('PelakuUsahaDashboard/JumlahJenisDokumen', {
          params: {
            years: _.models.year,
          }
        })
        .then(res => {
          _.jenisDokumen = res.data.data;
        })
      },
      getTimbulanPerKodeLimbah(){
        const _ = this;
        _.$axios.get('PelakuUsahaDashboard/TimbulanLimbahPerKodeLimbah', {
          params: {
            years: _.models.year,
          }
        })
        .then(res => {
          _.timbulanPerKodeLimbah = res.data.data;
        })
      }
    },
    beforeMount() {
        // Clean up the map instance when the component is destroyed
        if (this.map) {
            this.map.remove();
        }
    },
    created(){
      this.$axios.get('Authentication/me');
    }
  }
</script>